module.exports = __webpack_public_path__ + "media/images/emblems/Ascona-coat_of_arms-b0c101fb3092be681f2a494e902db529.svg";